<template lang="pug">
.v-accordion.accordion(v-if="accordion")
	.accordion__container.container
		.accordion__wrap
			h2.accordion__title(v-if="accordion.title") {{accordion.title}}
			.accordion__items-wrap
				.accordion__items
					template(v-for="(item, index) in accordion.items" :key="index")
						.accordion__item(:class="{'accordion__item--opened': item.opened}")
							button.accordion__item-bar(type="button" :class="{'accordion__item-bar--opened': item.opened}" @click="item.opened = !item.opened")
								.accordion__item-bar-text {{item.title}}
								.accordion__item-bar-icon
							v-collapse(:open="item.opened")
								.accordion__item-collapse
									.accordion__item-content.text-guide(v-html="item.text")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			accordion: null
		};
	},

	methods: {
		dataSet(data) {
			this.accordion = data;
		}
	}
};
</script>